import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import Loading from 'modules/loading';
import { isSignedIn } from 'modules/auth';

export default class PrivateRoute extends React.Component {
  static propTypes = {
    component: PropTypes.func,
    render: PropTypes.func,
    redirect: PropTypes.bool,
  };

  static defaultProps = {
    component: null,
    render: null,
  };

  static defaultProps = {
    redirect: false,
  };

  state = {
    isUserSignedIn: false,
    loaded: false,
  };

  updateSignIn = () => {
    isSignedIn().then((isUserSignedIn) => {
      if (this.state.isUserSignedIn !== isUserSignedIn || !this.state.loaded) {
        this.setState({ isUserSignedIn, loaded: true });
      }
    });
  };

  renderComponent = (props) => {
    if (this.props.render) {
      return this.props.render(props);
    }

    if (this.props.component) {
      const { component: Component } = this.props;

      return <Component {...props} />;
    }

    throw new Error('Missing render method in PrivateRoute');
  };

  render() {
    this.updateSignIn();

    // Because isSignedIn is a promise, need to wait until we get the result in state
    // before we render the conditional. <Redirect /> causes an immediate re-direct
    // and dismounting of this component.
    // Although isSignedIn is a promise, in web it actually executes sync so there
    // should never be a <Loading /> rendered due to this.
    if (!this.state.loaded) {
      return <Loading />;
    }

    const { component, ...rest } = this.props;

    // Pass on all the props and render the desired component if logged in, otherwise
    // redirect to signin page, or return null if no redirect desired
    return (
      <Route
        {...rest}
        render={(props) =>
          this.state.isUserSignedIn
            ? this.renderComponent(props)
            : this.props.redirect && (
                <Redirect
                  to={{
                    pathname: '/signin',
                    state: { from: props.location },
                  }}
                />
              )
        }
      />
    );
  }
}
